<script lang="ts">
  import { BADGE_ID } from "../..";

  export let header: string | null = "";
  export let text: string | null = "";
  export let modalCallback: () => void;
</script>

<div id={BADGE_ID} class="pina-badge">
  <div class="pina-badge-header-text">
    <a on:click={modalCallback}>{header}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      </a>
  </div>

  <p class="pina-badge-body-text">
    {text}
  </p>
</div>

<style>
  .pina-badge {
    font-family: 'Agenda-Regular';
    margin: 1rem 0;
      padding: 0.75rem;
    background: linear-gradient(160.6deg, rgb(162 142 254 / 20%) -62.4%, rgb(212 151 219 / 20%) -29.87%, rgb(229 136 199 / 20%) 8.44%, rgb(242 188 218 / 20%) 39.8%, rgb(166 184 235 / 20%) 70.64%, rgb(193 201 224 / 20%) 104.27%, rgb(178 191 230 / 20%) 141.57%);
    line-height: 0.6rem;
  }

  .pina-badge-header-text {
    font-weight: 700;
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }

  .pina-badge-header-text:hover {
    cursor: pointer;
  }

  .pina-badge-body-text {
    font-size: 0.9rem;
    line-height: normal;
    margin-top: 0.5rem;
  }
</style>
